import { Button, Modal } from '@catering/ui';
import type { JSX } from 'react';

export interface ConfirmationLine {
  positionId: string;
  menuName: string;
  quantity: number;
}

export interface ConfirmationModalProps {
  open: boolean;
  lines: ConfirmationLine[];
  onClose: () => void;
  onConfirm: () => void;
  confirming: boolean;
}

/**
 * `portal-orders/spec.md` → "Confirmación sin ningún monto en pesos":
 * shows quantities by menu only — no `unitPriceCents`, no total. Not a
 * rendering choice on top of data that includes it; `Order`/`OrderItem`
 * (`orders/api.ts`) never carry a price field to begin with.
 */
export function ConfirmationModal({
  open,
  lines,
  onClose,
  onConfirm,
  confirming,
}: ConfirmationModalProps): JSX.Element {
  return (
    <Modal open={open} onClose={onClose} title="Confirmar pedido">
      <ul className="flex flex-col gap-2">
        {lines.map((line) => (
          <li
            key={line.positionId}
            className="flex items-center justify-between border-b border-slate-100 py-2 text-sm last:border-none"
          >
            <span className="text-slate-900">{line.menuName}</span>
            <span className="font-medium text-slate-700">{line.quantity}</span>
          </li>
        ))}
      </ul>

      <div className="mt-6 flex gap-3">
        <Button variant="secondary" onClick={onClose} className="flex-1">
          Volver
        </Button>
        <Button onClick={onConfirm} loading={confirming} className="flex-1">
          Confirmar pedido
        </Button>
      </div>
    </Modal>
  );
}
